module.exports = __webpack_public_path__ + "40325704cfc046a204c53d7ac0f0e7f0.svg";